/* PROJ-67 Besties — Render-Engine. GETEILT: byte-identisch in
 * distantlines/assets/ und blanket_frontend/.
 *
 * Parität: alle Masse kommen aus BESTIES_LAYOUT in Druck-Pixeln und werden
 * ueber die Canvas-Breite auf cqw normiert. Der Container traegt
 * container-type:inline-size und aspect-ratio; damit ist die Containerbreite
 * der EINZIGE Unterschied zwischen Editor-Vorschau und Druckdatei.
 * Nichts hier darf px, vw, vh oder rem verwenden. */
(function (w) {
  'use strict';

  // Herz-Kontur, wortgleich aus kalender-poster.js (KP_HEART_PATH). Bewusst
  // kopiert statt importiert: die Engine muss byte-identisch in zwei Codebasen
  // liegen und darf nichts aus dem Theme nachladen. viewBox 0 0 220 200.
  var HEART_PATH = 'M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z';

  function slotFont(slot, L) {
    // Ein Slot darf eine eigene Schrift fuehren (names steht in Futura, der
    // Titel in Clash Display). Ohne Angabe gilt die erste aus dem Vertrag.
    return (slot && slot.font) || L.fonts[0].family;
  }

  function pct(v, total) { return (v / total) * 100; }

  function box(b, L) {
    return 'position:absolute;' +
      'left:' + pct(b.x, L.canvas.w) + 'cqw;' +
      'top:' + pct(b.y, L.canvas.w) + 'cqw;' +
      'width:' + pct(b.w, L.canvas.w) + 'cqw;' +
      (b.h ? 'height:' + pct(b.h, L.canvas.w) + 'cqw;' : '');
  }

  // Normierter Crop {x,y,w,h} in 0..1 -> Bild im Rahmen positionieren.
  // Aufloesungsunabhaengig: das S3-Original wird skaliert, nicht neu berechnet.
  //
  // WICHTIG, hart erkaempft: hier darf KEIN object-fit:cover stehen.
  // Die Prozentrechnung unten bildet das Crop-Rechteck exakt auf den Rahmen ab
  // und setzt dabei fill-Semantik voraus. Mit cover skaliert der Browser das
  // Bild ein zweites Mal und zentriert es, wodurch der angeforderte Ausschnitt
  // verloren geht. Nachgemessen: Crop {x:.25,y:0,w:.5,h:1} auf einem 1000x1000
  // Bild mit Streifen bei y 5-15% und 85-95% zeigt mit cover NULL Prozent
  // beider Streifen, mit fill korrekt je 10 Prozent.
  //
  // VERTRAG: Das Crop-Rechteck MUSS das Seitenverhaeltnis des Fotorahmens
  // haben. Der Editor stellt das sicher (Cropper.js mit aspectRatio des
  // Rahmens, plus aspektrichtiger Start-Crop). Sonst verzerrt fill das Bild.
  function cropStyle(c) {
    var cx = c && c.w ? c : { x: 0, y: 0, w: 1, h: 1 };
    return 'position:absolute;' +
      'width:' + (100 / cx.w) + '%;' +
      'height:' + (100 / cx.h) + '%;' +
      'left:' + (-(cx.x / cx.w) * 100) + '%;' +
      'top:' + (-(cx.y / cx.h) * 100) + '%;' +
      // PFLICHT, am lebenden Theme nachgemessen: das Shopify-Theme setzt
      // global img { max-width: 100% }. Diese Rechnung fordert fuer JEDEN
      // Zuschnitt mehr als 100 % an (100/cx.w) -- der Deckel schneidet das ab,
      // das Bild bleibt zu schmal und im Rahmen klafft eine Luecke, die mit
      // engerem Zuschnitt WAECHST. Gemessen: angefordert 800 px, geliefert
      // 200 px. Im Harness trat es nie auf, weil dort kein Theme-CSS laedt.
      'max-width:none;max-height:none;' +
      'object-fit:fill;';
  }

  function el(tag, style, cls) {
    var n = document.createElement(tag);
    if (style) n.style.cssText = style;
    if (cls) n.className = cls;
    return n;
  }

  /**
   * @param {HTMLElement} root  Container. Bekommt container-type + aspect-ratio gesetzt.
   * @param {Object} cfg        siehe Interfaces im Plan
   * @param {Object} L          window.BESTIES_LAYOUT
   * @returns {{fitText: Function}}
   */
  function renderBestiesDesign(root, cfg, L) {
    var v = L.variants[String(cfg.count)];
    if (!v) throw new Error('[besties] unbekannte Foto-Anzahl: ' + cfg.count);
    var theme = L.themes[cfg.theme] || L.themes.black;

    root.innerHTML = '';
    root.style.containerType = 'inline-size';
    root.style.aspectRatio = L.canvas.w + ' / ' + L.canvas.h;
    root.style.position = 'relative';
    root.style.overflow = 'hidden';

    // --- Titel: mehrzeilig, Zeile 1 gefuellt, die weiteren als Outline ------
    // Branchenueblicher Look: der Titel wiederholt sich, die Fotos laufen
    // darueber und verdecken die unteren Zeilen teilweise. Deshalb wird der
    // Titel VOR den Fotos eingehaengt (niedrigerer z-index durch DOM-Reihenfolge).
    var t = cfg.title || { mode: 'preset', value: '' };
    // z-index 2: der Titel liegt UEBER den Fotos. Die unteren Outline-Zeilen
    // laufen dadurch sichtbar ueber den Fotoblock, so wie in den Referenzen.
    // Ueber die DOM-Reihenfolge allein ginge es auch, aber explizit ist es
    // gegen spaetere Umsortierungen robust.
    var titleEl = el('div', box(v.title, L) +
      'display:flex;flex-direction:column;align-items:' +
      (v.title.align === 'left' ? 'flex-start' : 'center') + ';' +
      // lineHeight steuert, wie eng die Titelzeilen stehen. Bei 1 ragte die
      // dritte Zeile zu rund zwei Dritteln ihrer Hoehe ueber die Fotos.
      'line-height:' + (v.title.lineHeight || 1) + ';pointer-events:none;z-index:2;');
    titleEl.dataset.slot = 'title';
    var titleText = String(t.value || '').toUpperCase();
    var lineCount = v.title.lines || 1;
    var fontSize = pct(v.title.lineH, L.canvas.w);
    for (var li = 0; li < lineCount; li++) {
      var ln = el('div', 'font-family:' + slotFont(v.title, L) + ',sans-serif;font-weight:700;' +
        'font-size:' + fontSize + 'cqw;white-space:nowrap;' +
        (li === 0
          ? 'color:' + theme.ink + ';'
          : 'color:transparent;-webkit-text-stroke:' + pct(v.title.stroke || 4, L.canvas.w) + 'cqw ' + theme.ink + ';'));
      ln.textContent = titleText;
      ln.dataset.titleLine = String(li + 1);
      titleEl.appendChild(ln);
    }
    root.appendChild(titleEl);

    // --- Fotos -----------------------------------------------------------
    var photos = cfg.photos || [];
    v.photos.forEach(function (frame, i) {
      var holder = el('div', box(frame, L) + 'overflow:hidden;' +
        (L.photoStyle.radius ? 'border-radius:' + pct(L.photoStyle.radius, L.canvas.w) + 'cqw;' : ''));
      holder.dataset.slot = 'photo' + (i + 1);
      var p = photos[i];
      if (p && p.url) {
        // photoStyle.filter ist eine fertige CSS-Filterkette und wird
        // durchgereicht. Vorher stand hier ein Vergleich auf den Magic-String
        // 'grayscale' -- damit liess sich der Filter nur ein- oder ausschalten,
        // nicht einstellen, und das Shirt hing auf nacktem grayscale(1) fest,
        // waehrend alle Poster laengst grayscale(1) contrast(1.05) benutzen.
        var img = el('img', cropStyle(p.crop) +
          (L.photoStyle.filter ? 'filter:' + L.photoStyle.filter + ';' : ''));
        img.src = p.url;
        img.crossOrigin = 'anonymous';
        img.alt = '';
        holder.appendChild(img);
      } else {
        holder.style.background = 'rgba(128,128,128,.25)';
      }
      root.appendChild(holder);
    });


    // --- Symbolreihe unten links -----------------------------------------
    // Barcode, Marken-Monogramm, Herz, Kompass. Herz und Kompass stammen aus
    // Lucide (ISC-Lizenz, kommerziell frei), das Monogramm ist das echte
    // Distantlines-Favicon als einfarbiges PNG.
    //
    // DRUCK-HINWEIS: Der Slot ist rund 1,9 cm hoch. Unter etwa 0,5 mm
    // verschmiert DTG. Die Strichstaerken sind deshalb bewusst fett gesetzt,
    // besonders beim Kompass -- dessen Nadel ist das feinste Element der
    // ganzen Reihe. Beim Probedruck gezielt anschauen.
    function renderIcons() {
      var slot = v.icons;
      if (!slot) return;
      var wrap = el('div', box(slot, L) +
        'display:flex;align-items:center;gap:' + pct(34, L.canvas.w) + 'cqw;');
      wrap.dataset.slot = 'icons';
      var ink = theme.ink;
      var H = pct(slot.h, L.canvas.w) + 'cqw';

      function svg(inner, vb) {
        var d = document.createElement('div');
        d.style.cssText = 'height:' + H + ';display:flex;align-items:center;';
        d.innerHTML = '<svg viewBox="' + vb + '" height="100%" fill="none" ' +
          'stroke="' + ink + '" stroke-width="3.1" stroke-linecap="round" ' +
          'stroke-linejoin="round">' + inner + '</svg>';
        return d;
      }

      // Eigene Bild-Assets. Sie liegen in zwei Tintenfarben vor, weil ein PNG
      // sich nicht wie ein SVG umfaerben laesst.
      function png(name) {
        var i = el('img', 'height:' + H + ';width:auto;display:block;');
        i.src = (cfg.assetBase || '') + 'besties-icon-' + name + '-' +
                (cfg.theme === 'white' ? 'dark' : 'light') + '.png';
        i.alt = '';
        return i;
      }

      // 1. Barcode. Die Quelle ist auf 13 Balken UND auf geringere Hoehe
      //    beschnitten: die Icon-Hoehe bestimmt die Skalierung, ein reiner
      //    Breitenschnitt haette die Balken also nicht dicker gemacht.
      //    Duennster Balken so bei 0,62 mm, ueber der DTG-Grenze von rund 0,5 mm.
      wrap.appendChild(png('barcode'));

      // 2. Marken-Monogramm
      wrap.appendChild(png('dl'));

      // 3. Herz -- dieselbe Kontur wie auf dem Kalender-Poster
      //    (KP_HEART_PATH in kalender-poster.js), damit die Marke ein Herz hat
      //    und nicht zwei. Gefuellte Flaeche, keine Kontur.
      wrap.appendChild(svg(
        '<path d="' + HEART_PATH + '" fill="' + ink + '" stroke="none"/>',
        '0 0 220 200'));

      // 4. Kompass. Linien nachtraeglich verdickt, sonst lagen sie bei 0,38 mm.
      wrap.appendChild(png('compass'));

      root.appendChild(wrap);
    }
    renderIcons();

    // --- Fusszeile: Namen mit Fuellzeichen, Symbol-Slot, Spruch rechts -----
    // Branchenueblicher Aufbau: links der Name, dessen Zeile mit Schraegstrichen
    // bis zum Rand aufgefuellt wird, darunter eine Symbolreihe; rechts der
    // Spruch rechtsbuendig ueber mehrere Zeilen.
    function textSlot(slot, value, name, extra) {
      // Bewusst display:block statt flex. Bei flex wird der Text zu einem
      // anonymen Flex-Item und scrollWidth meldet dann nicht die Textbreite --
      // damit laeuft die Fuellzeichen-Schleife in fitText ins Leere.
      var n = el('div', box(slot, L) +
        'display:block;line-height:1.15;' +
        'text-align:' + (slot.align || 'center') + ';' +
        'color:' + theme.ink + ';' +
        'font-family:' + slotFont(slot, L) + ',sans-serif;font-weight:700;' +
        'font-size:' + pct(slot.size, L.canvas.w) + 'cqw;' + (extra || ''));
      n.dataset.slot = name;
      n.dataset.baseSize = String(slot.size);
      // Text in ein inline-block-Span: nur so ist die tatsaechliche Textbreite
      // messbar. scrollWidth eines Blocks ist nie KLEINER als clientWidth,
      // damit laesst sich "passt noch etwas rein?" nicht beantworten.
      var inner = document.createElement('span');
      inner.style.display = 'inline-block';
      inner.textContent = slot.case === 'upper'
        ? String(value || '').toUpperCase()
        : String(value || '');
      n.appendChild(inner);
      n._inner = inner;
      root.appendChild(n);
      return n;
    }
    // Namenszeile: Name links, Fuellstriche rechts. Die Striche liegen in einem
    // eigenen Element mit direction:rtl und overflow:hidden -- dadurch steht die
    // RECHTE Kante immer fest an der Rahmenkante und nur die Anzahl der Striche
    // aendert sich. Vorher wanderte die Kante mit der Namenslaenge.
    var namesEl = el('div', box(v.names, L) +
      'display:flex;align-items:baseline;gap:' + pct(18, L.canvas.w) + 'cqw;' +
      'color:' + theme.ink + ';white-space:nowrap;' +
      'font-family:' + slotFont(v.names, L) + ',sans-serif;font-weight:700;' +
      'font-size:' + pct(v.names.size, L.canvas.w) + 'cqw;');
    namesEl.dataset.slot = 'names';
    namesEl.dataset.baseSize = String(v.names.size);
    var nameSpan = document.createElement('span');
    nameSpan.style.display = 'inline-block';
    nameSpan.style.flex = '0 0 auto';
    nameSpan.textContent = v.names.case === 'upper'
      ? String(cfg.names || '').toUpperCase() : String(cfg.names || '');
    namesEl._inner = nameSpan;
    var fillSpan = document.createElement('span');
    fillSpan.style.cssText = 'flex:1 1 auto;overflow:hidden;text-align:right;';
    // rechtsbuendig: die Kette sitzt an der rechten Kante, die kleine
    // Restluecke (weniger als eine Zeichenbreite) liegt hinter dem Namen.
    // direction:rtl braucht es nicht mehr, seit nichts mehr ueberlaeuft.
    // Inneres Span: nur daran laesst sich die Breite EINES Zeichens messen.
    // Am Fuell-Element selbst geht es nicht -- dessen scrollWidth ist nie
    // kleiner als seine clientWidth, die Messung liefert dann Unsinn.
    var fillInner = document.createElement('span');
    fillInner.style.display = 'inline-block';
    fillSpan.appendChild(fillInner);
    namesEl._fillInner = fillInner;
    namesEl.appendChild(nameSpan);
    namesEl.appendChild(fillSpan);
    namesEl._fill = fillSpan;
    root.appendChild(namesEl);
    var quoteEl = textSlot(v.quote, cfg.quote, 'quote');
    // Ansage Dominik 08.08.: der Spruch unten rechts ist kursiv gesetzt.
    quoteEl.style.fontStyle = 'italic';
    // Ansage Dominik 09.08.: lange Sprueche brechen bei VOLLER Schriftgroesse
    // in die naechste Zeile um (kein Verkleinern). GIERIGER Standard-Umbruch
    // (erste Zeile voll, Rest in die zweite) — text-wrap:balance war kurz
    // drin und flog am selben Tag wieder raus, die balancierte Aufteilung
    // sah auf dem Shirt komisch aus. Maximal 2 Zeilen erzwingt fitQuoteLines.

    // --- Auto-Verkleinerung ----------------------------------------------
    // Muss NACH document.fonts.ready laufen, sonst wird gegen die
    // Ersatzschrift gemessen (Chromium-Default ist Times New Roman).
    function fitOne(node) {
      if (!node || !node.firstChild) return;
      var probe = node._inner || node;
      var inner = probe.offsetWidth || node.scrollWidth, outer = node.clientWidth;
      if (!outer || inner <= outer) return;
      var base = parseFloat(node.dataset.baseSize);
      var shrunk = base * (outer / inner) * 0.98;
      node.style.fontSize = pct(shrunk, L.canvas.w) + 'cqw';
    }
    // Titel: ALLE Zeilen gemeinsam auf die Rahmenbreite bringen. Vorher wurde
    // eine Zeile gegen sich selbst gemessen (clientWidth == eigene Textbreite),
    // dadurch konnte die Bedingung nie greifen und der Titel ragte heraus.
    // Misst die tatsaechliche TINTE eines Wortes, nicht sein Textkaestchen.
    // Noetig, weil die Vorbreite der Glyphen links und rechts verschieden ist:
    // ein U beginnt praktisch an der Kaestchenkante, ein H laesst rechts Luft.
    // Passt man nur das Kaestchen an, sitzt das Wort optisch trotzdem schief
    // ueber dem Fotoblock -- genau das war im Render zu sehen.
    // Setzt geladene Schriften voraus, laeuft deshalb nur aus fitText heraus.
    function inkMetrics(text, fontPx, family, spacingPx) {
      try {
        var c = document.createElement('canvas').getContext('2d');
        if (!c) return null;
        c.font = '700 ' + fontPx + 'px ' + family + ', sans-serif';
        // letterSpacing kennt Chromium seit Version 99. Faellt es aus, bleibt
        // die Sperrung bei 0 und der Titel wird eben nur nicht breiter.
        if (spacingPx) { try { c.letterSpacing = spacingPx + 'px'; } catch (e) {} }
        var m = c.measureText(text);
        if (typeof m.actualBoundingBoxRight !== 'number' ||
            typeof m.actualBoundingBoxLeft !== 'number') return null;
        // actualBoundingBoxLeft zaehlt nach LINKS positiv. Die Tinte beginnt
        // also bei -actualBoundingBoxLeft, gemessen ab dem Setzpunkt.
        return {
          left: -m.actualBoundingBoxLeft,
          width: m.actualBoundingBoxLeft + m.actualBoundingBoxRight,
          adv: m.width          // Vorschubbreite = Breite des Textkaestchens
        };
      } catch (e) { return null; }
    }

    function applyTitleSize(sizePrint, trackPrint, stretch) {
      for (var j = 0; j < titleEl.children.length; j++) {
        var n = titleEl.children[j];
        n.style.fontSize = pct(sizePrint, L.canvas.w) + 'cqw';
        n.style.letterSpacing = trackPrint
          ? pct(trackPrint, L.canvas.w) + 'cqw' : '';
        // Waagerechtes Ziehen als letzte Reserve. Um die Mitte skaliert, damit
        // die Zentrierung erhalten bleibt. Macht senkrechte Striche DICKER,
        // im DTG also unkritisch -- duenner wird nichts.
        n.style.transformOrigin = 'center';
        n.style.transform = (stretch && stretch !== 1)
          ? 'scaleX(' + stretch + ')' : '';
      }
    }

    // Unterkante der TINTE der letzten Titelzeile, in Druckpixeln ab der
    // Oberkante der Leinwand. Gemessen statt gerechnet, weil der Abstand
    // zwischen Zeilenkasten und Tinte von den Schriftmetriken abhaengt.
    function titleGeometry(k) {
      var last = titleEl.children[titleEl.children.length - 1];
      if (!last || !k) return null;
      try {
        var cs = window.getComputedStyle(last);
        var c = document.createElement('canvas').getContext('2d');
        if (!c) return null;
        c.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        var m = c.measureText(last.textContent);
        if (typeof m.actualBoundingBoxAscent !== 'number') return null;
        var cap = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
        var r = last.getBoundingClientRect();
        var rootR = root.getBoundingClientRect();
        var lead = (r.height - cap) / 2;      // halber Durchschuss
        return { bottom: ((r.top - rootR.top) + lead + cap) / k, cap: cap / k };
      } catch (e) { return null; }
    }

    // Feste Werte fuer einen einzelnen Titel, die die Automatik schlagen.
    // Die Titelliste ist geschlossen, also darf Dominik jeden Titel von Hand
    // stellen. Die Automatik bleibt trotzdem der Standard: ein spaeter
    // ergaenzter Titel ohne Eintrag laeuft dadurch nicht ueber die Fotos.
    // Form: L.titleTuning['BESTIES'] = { size: 197, tracking: 39, stretch: 1.7 }
    function titleOverride(text) {
      var t = L.titleTuning && L.titleTuning[text];
      return (t && typeof t === 'object') ? t : null;
    }

    function fitTitle() {
      if (!titleEl || !titleEl.firstChild) return;
      // Nicht bis an die Fotokanten: fillRatio laesst bewusst Luft, sonst wirkt
      // ein langes Wort wie UNZERTRENNLICH uebertrieben breit.
      var avail = titleEl.clientWidth * (v.title.fillRatio || 1);
      if (!avail) return;
      var widest = 0, i;
      for (i = 0; i < titleEl.children.length; i++) {
        widest = Math.max(widest, titleEl.children[i].offsetWidth);
      }
      if (!widest) return;
      // Der Titel fuellt die Rahmenbreite IMMER aus, wird also auch vergroessert.
      // So steht er buendig ueber dem Fotoblock, wie in den Referenzen.
      // maxScale verhindert, dass ein sehr kurzer Titel grotesk gross wird.
      var base = v.title.lineH;
      var maxScale = v.title.maxScale || 2.4;
      var k = root.clientWidth / L.canvas.w;   // Druckpixel -> CSS-Pixel
      var text = titleEl.children[0].textContent;
      var family = slotFont(v.title, L);
      var size = base * Math.min(avail / widest, maxScale);
      var shift = 0;

      if (k > 0) {
        var capPx = base * maxScale * k;
        var fontPx = Math.min(size * k, capPx);
        var m = inkMetrics(text, fontPx, family);
        // Nachmessen statt einmal hochrechnen: die Tintenbreite waechst nicht
        // exakt linear mit der Schriftgroesse (Hinting, Rundung).
        for (var pass = 0; pass < 4 && m && m.width > 0; pass++) {
          var corr = avail / m.width;
          if (Math.abs(corr - 1) < 0.0005 || fontPx >= capPx) break;
          fontPx = Math.min(fontPx * corr, capPx);
          m = inkMetrics(text, fontPx, family);
        }
        if (m && m.width > 0) size = fontPx / k;
      }

      var sizeFill = size;                  // fuellt die Breite ohne Sperrung
      applyTitleSize(size, 0);

      // Groesse, bei der die Zeilen nur um maxOverlap ihrer Hoehe in die Fotos
      // ragen. Das ist der Wunschwert, aber KEINE harte Grenze mehr: bei einem
      // kurzen Wort muesste die Sperrung sonst absurd weit stehen, und dann
      // liest sich BESTIES als sieben Einzelbuchstaben statt als Wort.
      var photoTop = (v.photos && v.photos[0]) ? v.photos[0].y : null;
      var maxOv = (typeof v.title.maxOverlap === 'number') ? v.title.maxOverlap : 0.2;
      var sizeCap = size;
      if (photoTop !== null && k > 0) {
        for (var g = 0; g < 4; g++) {
          var geo = titleGeometry(k);
          if (!geo || !geo.cap) break;
          var allowed = photoTop + maxOv * geo.cap;
          if (geo.bottom <= allowed) break;
          // Alle Masse skalieren linear mit der Schriftgroesse, gemessen ab
          // der Oberkante des Titelrahmens.
          // Ein Druckpixel Sicherheit, sonst landet das Ergebnis durch
          // Rundung minimal ueber der Grenze.
          var f = (allowed - 1 - v.title.y) / (geo.bottom - v.title.y);
          if (!(f > 0 && f < 1)) break;
          sizeCap *= f;
          applyTitleSize(sizeCap, 0);
        }
      }

      // Die kleinste Groesse, bei der die Breite noch mit hoechstens
      // maxTracking Sperrung erreicht wird. Tintenbreite waechst linear mit der
      // Groesse, also: avail = w1*S + tau*S*(n-1)  ->  S = avail/(w1+tau*(n-1)).
      var tau = (typeof v.title.maxTracking === 'number') ? v.title.maxTracking : 0.4;
      var sizeTrack = 0;
      if (k > 0 && text.length > 1) {
        var mFill = inkMetrics(text, sizeFill * k, family, 0);
        if (mFill && mFill.width > 0) {
          var w1 = (mFill.width / k) / sizeFill;
          sizeTrack = (avail / k) / (w1 + tau * (text.length - 1));
        }
      }

      // Reihenfolge der Reserven, wenn die Breite bei gedeckelter Groesse nicht
      // reicht: erst sperren, dann waagerecht ziehen, und erst wenn beides
      // ausgereizt ist, groesser werden und die Ueberlappung nachgeben lassen.
      // maxStretch dehnt die verfuegbare Breite rechnerisch, deshalb geht
      // sizeTrack durch diesen Faktor.
      var maxStretch = (typeof v.title.maxStretch === 'number') ? v.title.maxStretch : 1;
      size = Math.min(sizeFill, Math.max(sizeCap, sizeTrack / maxStretch));
      applyTitleSize(size, 0, 1);

      // Restliche Breite ueber den Buchstabenabstand holen. Kein Verzerren,
      // die Buchstaben behalten ihre Form.
      var track = 0;
      if (k > 0 && text.length > 1) {
        var maxTrack = size * tau;
        for (var s2 = 0; s2 < 4; s2++) {
          var mt = inkMetrics(text, size * k, family, track * k);
          if (!mt || !(mt.width > 0)) break;
          var fehlt = (avail - mt.width) / k;          // in Druckpixeln
          if (Math.abs(fehlt) < 0.5) break;
          track += fehlt / (text.length - 1);
          if (track < 0) { track = 0; break; }
          if (track > maxTrack) { track = maxTrack; break; }
        }
      }
      // Was die Sperrung nicht schafft, holt das waagerechte Ziehen.
      var stretch = 1;
      var mS = inkMetrics(text, size * k, family, track * k);
      if (mS && mS.width > 0) {
        stretch = Math.min(maxStretch, Math.max(1, avail / mS.width));
      }

      // Handeinstellung schlaegt die Automatik, feldweise.
      var ov = titleOverride(text);
      if (ov) {
        if (typeof ov.size === 'number') size = ov.size;
        if (typeof ov.tracking === 'number') track = ov.tracking;
        if (typeof ov.stretch === 'number') stretch = ov.stretch;
      }

      applyTitleSize(size, track, stretch);

      // Waagerechte Feinlage erst JETZT bestimmen: Groesse und Sperrung stehen,
      // und die Vorbreiten haengen an beidem.
      var mf = inkMetrics(text, size * k, family, track * k);
      if (mf && mf.width > 0) {
        if (v.title.align === 'center') {
          // Zentriert wuerde sonst das Textkaestchen. Dessen Vorbreiten sind
          // links und rechts verschieden, und die Sperrung haengt zusaetzlich
          // hinter dem letzten Buchstaben -- das Wort saehe verschoben aus.
          // Mal stretch, weil scaleX um die Kaestchenmitte skaliert und den
          // Versatz der Tintenmitte dadurch mitvergroessert.
          var bRight = mf.adv - (mf.left + mf.width);
          shift = (stretch * (mf.left - bRight) / 2) / k;
        } else {
          shift = mf.left / k;              // linke Vorbreite in Druckpixeln
        }
      }

      // Um die Vorbreite nach links ziehen, damit die TINTE an der Rahmenkante
      // beginnt. transform statt margin: verschiebt rein optisch und laesst
      // die Kaestchenbreite in Ruhe, an der die Messung oben haengt.
      titleEl.style.transform = shift
        ? 'translateX(' + pct(-shift, L.canvas.w) + 'cqw)'
        : '';
    }

    // Striche auffuellen: so viele, dass die rechte Kante buendig ist. Durch
    // direction:rtl wird links abgeschnitten, die rechte Kante steht deshalb
    // fest, egal wie lang der Name ist.
    function fillNames() {
      var fc = v.names && v.names.fillChar;
      var fill = namesEl && namesEl._fill;
      var inner = namesEl && namesEl._fillInner;
      if (!fc || !fill || !inner) return;
      // Striche auf Versalhoehe bringen (Ansage Dominik 08.08.): der
      // Schraegstrich ueberragt in Futura die Grossbuchstaben und unterschreitet
      // die Grundlinie -- er wirkte dadurch groesser als der Name. Tinte messen
      // statt raten, dann gilt es fuer jede Schrift. Zusaetzlich die Unterkante
      // des skalierten Strichs auf die Grundlinie heben (rein optisch per
      // relative/top, damit die Breitenmessung darunter unberuehrt bleibt).
      try {
        var cs = window.getComputedStyle(namesEl);
        var c = document.createElement('canvas').getContext('2d');
        if (c) {
          c.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
          var mH = c.measureText('H');
          var mS = c.measureText(fc);
          if (typeof mH.actualBoundingBoxAscent === 'number' &&
              typeof mS.actualBoundingBoxAscent === 'number') {
            var cap = mH.actualBoundingBoxAscent;
            var slash = mS.actualBoundingBoxAscent + mS.actualBoundingBoxDescent;
            if (cap > 0 && slash > cap) {
              var fFill = cap / slash;
              inner.style.fontSize = (fFill * 100).toFixed(1) + '%';
              inner.style.position = 'relative';
              inner.style.top = '-' + (mS.actualBoundingBoxDescent * fFill).toFixed(2) + 'px';
            } else {
              inner.style.fontSize = '';
              inner.style.top = '';
            }
          }
        }
      } catch (e) {}
      var avail = fill.clientWidth;
      if (avail <= 0) { inner.textContent = ''; return; }
      // Nur GANZE Zeichen. Kein Ueberfuellen mit anschliessendem Abschneiden --
      // dabei bliebe links ein halber Strich stehen. Stattdessen wird die
      // groesste Anzahl gesucht, die noch vollstaendig hineinpasst; der Rest
      // bleibt als kleine Luecke hinter dem Namen. Durch direction:rtl sitzt
      // die Kette rechtsbuendig, die rechte Kante steht damit fest.
      inner.textContent = fc;
      var one = inner.offsetWidth || 1;
      var count = Math.max(0, Math.floor(avail / one));
      inner.textContent = new Array(count + 1).join(fc);
      var guard = 0;
      // nach oben tasten, solange es noch vollstaendig passt
      while (guard++ < 400) {
        inner.textContent = new Array(count + 2).join(fc);
        if (inner.offsetWidth > avail) break;
        count++;
      }
      // nach unten korrigieren, bis es sicher passt
      guard = 0;
      while (count > 0 && guard++ < 400) {
        inner.textContent = new Array(count + 1).join(fc);
        if (inner.offsetWidth <= avail) break;
        count--;
      }
      inner.textContent = count > 0 ? new Array(count + 1).join(fc) : '';
    }

    // Ansage Dominik 09.08.: der Spruch belegt hoechstens ZWEI Zeilen.
    // Normalfall: balance bricht Freitext (Limit 50) ohnehin in <=2 Zeilen.
    // Nur wenn viele breite Glyphen eine dritte Zeile erzwingen, wird die
    // Schrift schrittweise verkleinert, bis zwei reichen — laeuft identisch
    // im Editor und im Print (geteilte Engine), Paritaet bleibt.
    function fitQuoteLines() {
      var inner = quoteEl && quoteEl._inner;
      if (!inner || !inner.textContent) return;
      var maxZeilen = (v.quote && v.quote.maxLines) || 2;
      var base = parseFloat(quoteEl.dataset.baseSize);
      var guard = 0;
      while (guard++ < 12) {
        var r = document.createRange();
        r.selectNodeContents(inner);
        var rects = r.getClientRects(), zeilen = 0;
        for (var i = 0; i < rects.length; i++) if (rects[i].width > 1) zeilen++;
        if (zeilen <= maxZeilen) break;
        base *= 0.94;
        quoteEl.style.fontSize = pct(base, L.canvas.w) + 'cqw';
      }
    }

    // Fusszeile ausrichten (Ansage Dominik 09.08., zweite Runde):
    //  - Der Spruch-Slot ist ein ZWEIZEILEN-Fach. EINE Zeile sitzt vertikal
    //    mittig im Fach (halbe Zeilenhoehe Vorschub), zwei Zeilen fuellen es.
    //  - Die Symbolreihe links ist so hoch wie das Fach (143 = 2 Zeilen) und
    //    ihre UNTERKANTE schliesst mit der Unterkante der Buchstaben ab,
    //    also der Baseline der zweiten Zeile — NICHT mit dem Zeilenkasten,
    //    der unter der Baseline noch Unterlaengen-Luft traegt. Der
    //    Baseline-Abstand kommt aus echten Font-Metriken (canvas measureText,
    //    laeuft nach fontsReady, sonst wuerde die Ersatzschrift gemessen).
    function alignFooter() {
      var iconsEl = root.querySelector('[data-slot="icons"]');
      if (!iconsEl || !quoteEl || !quoteEl._inner) return;
      var LINE = v.quote.size * 1.15;
      var r = document.createRange();
      r.selectNodeContents(quoteEl._inner);
      var rects = r.getClientRects(), zeilen = 0;
      for (var i = 0; i < rects.length; i++) if (rects[i].width > 1) zeilen++;
      quoteEl.style.paddingTop = zeilen <= 1 ? pct(LINE / 2, L.canvas.w) + 'cqw' : '0px';
      var descent = 0.2 * v.quote.size;
      try {
        var c = document.createElement('canvas').getContext('2d');
        c.font = 'italic 700 100px "' + slotFont(v.quote, L) + '", sans-serif';
        var tm = c.measureText('Hg');
        if (tm && tm.fontBoundingBoxDescent) {
          descent = (tm.fontBoundingBoxDescent / 100) * v.quote.size;
        }
      } catch (e) {}
      var halfLead = ((1.15 - 1) / 2) * v.quote.size;
      var unterkante = v.quote.y + 2 * LINE - descent - halfLead;
      iconsEl.style.top = pct(unterkante - v.icons.h, L.canvas.w) + 'cqw';
    }

    function fitText() {
      fitTitle();
      fitOne(namesEl);
      fitOne(quoteEl);
      fitQuoteLines();
      alignFooter();
      fillNames();
    }

    // document.fonts.ready allein reicht NICHT. Es loest sofort aus, wenn zu
    // dem Zeitpunkt noch kein Ladevorgang laeuft -- und Chromium fordert eine
    // Webschrift erst an, wenn Text damit gesetzt wird. Der Screenshot fiel
    // dadurch vor der Schrift, der Druck kam in der Ersatzschrift heraus,
    // obwohl die Datei erreichbar war. Also erst gezielt anfordern, dann warten.
    function fontsReady() {
      if (!document.fonts || !document.fonts.ready) return Promise.resolve();
      var wanted = (L.fonts || []).map(function (f) {
        return document.fonts.load(
          (f.weight || 400) + ' 100px "' + f.family + '"');
      });
      return Promise.all(wanted)
        .catch(function () { /* fehlende Schrift darf den Render nicht kippen */ })
        .then(function () { return document.fonts.ready; });
    }

    return { fitText: fitText, fontsReady: fontsReady };
  }

  w.renderBestiesDesign = renderBestiesDesign;
})(window);
